import { PrescribedItemErrors } from '../../types/prescription'
import { AustralianState } from '../../types'

export const QUANTITY_MUST_BE_GREATER_THAN_ZERO_MESSAGE = 'Quantity must be greater than 0.'

export const REQUIRE_AUTHORITY_MESSAGE = 'Requires Online/Phone Authority'

export const initFormError: PrescribedItemErrors = {
  patientInstructions: {
    showError: false,
    message: 'Please enter directions',
  },
  reasonForPrescribing: {
    showError: false,
    message: 'Please enter reason for prescribing',
  },
  quantity: {
    showError: false,
    message: QUANTITY_MUST_BE_GREATER_THAN_ZERO_MESSAGE,
  },
  pbsAuthority: {
    showError: false,
    message: REQUIRE_AUTHORITY_MESSAGE,
  },
}

export const RTPM_CHECK_REQUIRED_STATE = [
  AustralianState.WesternAustralia,
  AustralianState.Victoria,
  AustralianState.SouthAustralia,
  AustralianState.NorthernTerritory,
  AustralianState.Queensland,
  AustralianState.Tasmania,
]

export const RTPM_SYSTEM_MAPPING = {
  [AustralianState.AustralianCapitalTerritory]: 'Canberra Script',
  [AustralianState.NewSouthWales]: 'SafeScript NSW',
  [AustralianState.NorthernTerritory]: 'NTScript',
  [AustralianState.Queensland]: 'QScript',
  [AustralianState.WesternAustralia]: 'ScriptCheckWA',
  [AustralianState.Tasmania]: 'TasScript',
  [AustralianState.Victoria]: 'SafeScript',
  [AustralianState.SouthAustralia]: 'ScriptCheck SA',
}
